import SettingsContext from './SettingsContext'

const SettingsConsumer = SettingsContext.Consumer ;

export default SettingsConsumer ;